module.exports = __webpack_public_path__ + "img/olist-pax.fa2df70c.svg";